import React from "react";
import { Container, Paper, Box, Skeleton } from "@mui/material";
import Authenticated from "../Layouts/Authenticated";

const UserProfileSkeleton: React.FC = () => {
  return (
    <Authenticated>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box
          sx={{
            display: "flex",
            gap: 4,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box sx={{ width: { xs: "100%", md: "33%" } }}>
            <Paper sx={{ p: 3 }}>
              <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
              <Skeleton
                variant="circular"
                width={144}
                height={144}
                sx={{ mx: "auto", display: "block", mb: 2 }}
              />
              <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
              <Skeleton variant="text" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" height={24} sx={{ mb: 3 }} />
              <Skeleton variant="rectangular" height={150} />
            </Paper>
          </Box>
          <Box sx={{ width: { xs: "100%", md: "67%" } }}>
            <Paper sx={{ p: 3, mb: 3 }}>
              <Skeleton variant="text" height={40} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" height={100} />
            </Paper>
            <Paper sx={{ p: 3 }}>
              <Skeleton variant="text" height={40} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" height={200} />
            </Paper>
          </Box>
        </Box>
      </Container>
    </Authenticated>
  );
};

export default UserProfileSkeleton;
